import { useDispatch, useSelector } from 'react-redux';
import { chosenFilterIdSelector } from '../containers/Documents/store/selectors/new-document.selector';
import { useCallback } from 'react';
import resetDocumentDefaultFilter from '../containers/Documents/requests/resetDocumentDefaultFilter';
import { actions } from '../containers/Documents/store/actions/new-document.actions';
import { documentsConstants } from '../containers/Documents/constants/documents.constants';
import { filterNewConst } from '../containers/Documents/constants/documentFilterNew.constantas';

const { RESET_FILTER_DOCUMENT } = filterNewConst;

const useResetDocumentFilter = () => {
  const dispatch = useDispatch();

  const chosenFilterId = useSelector(chosenFilterIdSelector);

  const handleResetDocumentFilter = useCallback(() => {
    resetDocumentDefaultFilter(chosenFilterId);
    dispatch({ type: RESET_FILTER_DOCUMENT });
    dispatch({
      type: documentsConstants.SET_EXPIRED_MODE,
      payload: false,
    });

    dispatch(actions.setChosenDocumentsFilter({ id: null, name: null }));
  }, [dispatch, chosenFilterId]);

  return handleResetDocumentFilter;
};

export default useResetDocumentFilter;
